"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FormBlock = _interopRequireDefault(require("../../../components/FormBlock"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _operators = _interopRequireDefault(require("./operators.js"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _cccisdFormik = require("cccisd-formik");
var _Level = _interopRequireDefault(require("./Level"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
var _style = _interopRequireDefault(require("./Level/style.css"));
var _excluded = ["values", "setValues", "errors"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validate = exports.validate = function validate(values) {
  var errors = {};
  var process = function process(item, path) {
    if (!item) {
      return;
    }
    if (item.aggregation) {
      item.conditions.forEach(function (condition, index) {
        return process(condition, path ? "".concat(path, ".conditions[").concat(index, "]") : "conditions[".concat(index, "]"));
      });
    } else if (!item.dataConnector) {
      errors["".concat(path, ".dataConnector")] = 'Choose data connector';
    } else if (!item.operator || item.operator === '0') {
      errors["".concat(path, ".operator")] = 'Choose operator';
    } else {
      var operatorSettings = (0, _find2["default"])(_operators["default"][item.dataConnector.type], {
        code: item.operator
      });
      if (operatorSettings.isValue) {
        if (operatorSettings.valueType === 'string' && (!item.value || item.value === '')) {
          errors["".concat(path, ".value")] = 'Enter some string';
        }
        if (operatorSettings.valueType === 'number' && item.value !== 0 && (!item.value || !(0, _isInt["default"])(item.value.toString()))) {
          errors["".concat(path, ".value")] = 'Enter valid number';
        }
      }
    }
  };
  process(values, '');
  return errors;
};

// Convert old format to the new format just to avoid breaking changes
var getShowConditionsRulesValue = function getShowConditionsRulesValue(value) {
  if (!value) {
    return null;
  }
  if (Array.isArray(value) && value.length === 0) {
    return null;
  }
  if (!value.aggregation) {
    return {
      aggregation: 'all',
      conditions: value
    };
  }
  return value;
};
var ShowConditionsBlock = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(ShowConditionsBlock, _React$Component);
  function ShowConditionsBlock() {
    _classCallCheck(this, ShowConditionsBlock);
    return _callSuper(this, ShowConditionsBlock, arguments);
  }
  _createClass(ShowConditionsBlock, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props$fields = this.props.fields,
        showConditionsExpanded = _this$props$fields.showConditionsExpanded,
        showConditionsRules = _this$props$fields.showConditionsRules;
      var DataConnectorsPicker = this.props.DataConnectorsPicker;
      if (!DataConnectorsPicker) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
        title: "Visibility/Logic",
        type: this.props.formBlockType,
        show: showConditionsExpanded.value,
        handleClick: function handleClick(show) {
          return showConditionsExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: getShowConditionsRulesValue(showConditionsRules.value),
        isInitialValid: false,
        validate: validate,
        onSubmit: function onSubmit() {},
        onAnyChange: function onAnyChange(values) {
          if ((0, _isEmpty2["default"])(validate(values))) {
            showConditionsRules.onChange(values);
          }
        },
        render: function render(_ref) {
          var values = _ref.values,
            setValues = _ref.setValues,
            errors = _ref.errors,
            rest = _objectWithoutProperties(_ref, _excluded);
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, values && values.aggregation ? /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              marginBottom: '-1em'
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              alignItems: 'flex-start'
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"]["delete"],
            style: {
              paddingTop: '0.5em'
            },
            onClick: function onClick() {
              setValues(null);
            }
          }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              flexGrow: 1
            }
          }, /*#__PURE__*/_react["default"].createElement(_Level["default"], {
            path: "",
            values: values,
            DataConnectorsPicker: DataConnectorsPicker,
            getDataConnectorMeta: _this.props.getDataConnectorMeta
          })))) : /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-default",
            onClick: function onClick() {
              setValues({
                aggregation: 'all',
                conditions: [{
                  id: 1,
                  dataConnector: null,
                  operator: '0',
                  value: ''
                }]
              });
            }
          }, "Add condition"));
        }
      }));
    }
  }]);
  return ShowConditionsBlock;
}(_react["default"].Component);
_defineProperty(ShowConditionsBlock, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  formBlockType: _propTypes["default"].string.isRequired,
  DataConnectorsPicker: _propTypes["default"].func,
  getDataConnectorMeta: _propTypes["default"].func
});